import { render, staticRenderFns } from "./karteikarte.vue?vue&type=template&id=f506a0f8&scoped=true&"
import script from "./karteikarte.vue?vue&type=script&lang=js&"
export * from "./karteikarte.vue?vue&type=script&lang=js&"
import style0 from "./karteikarte.vue?vue&type=style&index=0&id=f506a0f8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f506a0f8",
  null
  
)

export default component.exports